<aw-dialog
  (onClose)="dialogRef.close($event)"
  [content]="content"
  [width]="width"
  [data]="data"
  [icon]="data.icon"
  [iconBackgroundColor]="data.iconBackgroundColor"
  [title]="data.headline"
  [isSaveDialog]="true">
  <ng-template #content>
    <p>
      {{ cmsTextProvider.shared.resetChangesWarning }}
    </p>
  </ng-template>
</aw-dialog>
